export default function(editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const pfx = c.pfx;

  if (c.blocks.indexOf(c.refs.preBuiltSectionRef) >= 0) {
    bm.add(c.refs.preBuiltSectionRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"/></svg>
          <div class="gjs-block-label">${c.label}</div>`,
      category: c.category,
      activate: true,
      select: true,
      content: `
        <div class='${pfx} width100' style="width:100%" data-js=${c.refs.preBuiltSectionRef} data-gjs-type=${c.refs.preBuiltSectionRef}>
        </div>`,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info">
          <a target="_blank" href="https://academy.drapcode.com/docs/app-pre-built-section/introduction-to-pre-built-section" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.label
      }?"></i>
          </a>
        </span>
      `,
    });
  }
}
